import React from "react";
import { Modal } from "@redriver/cinnamon";
import { Grid } from "semantic-ui-react";

function formatBytes(b) {
  if (b < 1024) {
    return Number(b).toLocaleString() + " B";
  }
  b /= 1024;
  if (b < 1024) {
    return Number(Math.round(b * 1000) / 1000).toLocaleString() + " KB";
  }
  b /= 1024;
  if (b < 1024) {
    return Number(Math.round(b * 1000) / 1000).toLocaleString() + " MB";
  }
  b /= 1024;
  return Number(Math.round(b * 1000) / 1000).toLocaleString() + " GB";
}

const TunnelModal = ({ data, stats, ...props }) => {
  if (!data) return null;
  return (
    <Modal.Information
      header={data.title}
      submitLabel="Close tunnel"
      {...props}
    >
      {data.comment ? <p>{data.comment}</p> : null}

      <Grid>
        <Grid.Row>
          <Grid.Column width={12}>
            <textarea readOnly value={data.command} style={{ width: "100%" }} />
          </Grid.Column>
        </Grid.Row>
        {stats ? (
          <Grid.Row>
            <Grid.Column width={4}>
              <h3>Status</h3>
              {stats.ConnectedClient ? (
                <p>Connected client: {stats.ConnectedClient}</p>
              ) : (
                <p>Client not connected</p>
              )}
              {stats.ServerConnected ? (
                <p>Server connected</p>
              ) : (
                <p>Server not connected</p>
              )}
              {stats.AutoCloseUtc ? (
                <p>
                  Auto-close at{" "}
                  {new Date(stats.AutoCloseUtc).toLocaleTimeString()}
                </p>
              ) : null}
            </Grid.Column>
            <Grid.Column width={4}>
              <h3>Client &rarr; Server</h3>
              <p>{formatBytes(stats.ClientToServerBytes)}</p>
            </Grid.Column>
            <Grid.Column width={4}>
              <h3>Server &rarr; Client</h3>
              <p>{formatBytes(stats.ServerToClientBytes)}</p>
            </Grid.Column>
          </Grid.Row>
        ) : null}
      </Grid>
    </Modal.Information>
  );
};

export default TunnelModal;
